import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=52cdbd60&scoped=true"
import script from "./SendOrder.vue?vue&type=script&lang=js"
export * from "./SendOrder.vue?vue&type=script&lang=js"
import style0 from "./SendOrder.vue?vue&type=style&index=0&id=52cdbd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdbd60",
  null
  
)

export default component.exports